import { DBDef_Action, DBDef_OrderGroup, DBDef_Pathway, DBDef_PathwayState, DBDef_PathwayTransition, pathwayAction_isInterflow, pathwayAction_isOrder } from '@app/pathway-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { currentTimeMillis, filterInstances, md5 } from '@nu-art/ts-common';
import { ModuleFE_Advisor_AdvisorSnippet } from './advisor-context.js';
import { ModuleFE_Advisor_ContextRule } from './healthcare-space.js';
export const dispatch_onActionChanged = new ThunderDispatcherV3('__onActionUpdated');
class ModuleFE_Advisor_Action_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_Action, dispatch_onActionChanged);
        this.registerVersionUpgradeProcessor('1.0.5', this.upgrade_105_106);
    }
    is = { order: pathwayAction_isOrder, interflow: pathwayAction_isInterflow };
    upgrade_105_106 = async (items) => {
        const snippetsToUpdate = [];
        const contextRulesToUpdate = [];
        for (const item of items) {
            if (!this.is.order(item))
                continue;
            const _item = item;
            const excludedVariableIds = [..._item.excludedVariableIds ?? []];
            const rules = [..._item.rules ?? []];
            // delete irrelevant props
            delete _item.excludedVariableIds;
            delete _item.rules;
            const currentTime = currentTimeMillis();
            const dbContextRule = {
                _id: md5(`${_item._id}-context-rules`),
                label: `${_item.name} - Context Rules`,
                rules,
                excludedVariableIds,
                _v: '1.0.0',
                _tagIds: filterInstances(rules.flatMap(rule => rule.tagIds)),
                __created: currentTime,
                __updated: currentTime
            };
            const dbSnippet = {
                _id: md5(`${_item._id}-snippet`),
                label: `${_item.name} - Snippet`,
                contextRuleId: dbContextRule._id,
                config: {
                    showChiefComplaints: true,
                    produceChiefComplaint: false,
                    onlyChiefComplaints: false,
                },
                _v: '1.0.9',
                __updated: currentTime,
                __created: currentTime,
                __variableIds: []
            };
            contextRulesToUpdate.push(dbContextRule);
            snippetsToUpdate.push(dbSnippet);
            item.snippetId = dbSnippet._id;
        }
        await Promise.all([
            ModuleFE_Advisor_AdvisorSnippet.onEntriesUpdated(snippetsToUpdate),
            ModuleFE_Advisor_ContextRule.onEntriesUpdated(contextRulesToUpdate)
        ]);
    };
}
export const ModuleFE_Advisor_Action = new ModuleFE_Advisor_Action_Class();
export const dispatch_onOrderGroupChanged = new ThunderDispatcherV3('__onOrderGroupUpdated');
class ModuleFE_Advisor_OrderGroup_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_OrderGroup, dispatch_onOrderGroupChanged);
    }
}
export const ModuleFE_Advisor_OrderGroup = new ModuleFE_Advisor_OrderGroup_Class();
export const dispatch_onPathwayChanged = new ThunderDispatcherV3('__onPathwayUpdated');
class ModuleFE_Advisor_Pathway_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_Pathway, dispatch_onPathwayChanged);
        this.registerVersionUpgradeProcessor('1.0.2', this.upgrade_102);
    }
    upgrade_102 = async (items) => {
        items.forEach(item => {
            const pathway = item;
            pathway.variableIds = filterInstances([item.variableId]);
            delete item.variableId;
        });
    };
}
export const ModuleFE_Advisor_Pathway = new ModuleFE_Advisor_Pathway_Class();
export const dispatch_onPathwayStateChanged = new ThunderDispatcherV3('__onPathwayStateUpdated');
class ModuleFE_Advisor_PathwayState_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_PathwayState, dispatch_onPathwayStateChanged);
        this.registerVersionUpgradeProcessor('1.0.4', this.upgrade_1_0_4);
        this.registerVersionUpgradeProcessor('1.0.5', this.update_105);
    }
    upgrade_1_0_4 = async (dbInstances) => {
        dbInstances.forEach(pathwayState => {
            const _pathwayState = pathwayState;
            _pathwayState.pathwayIds = [pathwayState.pathwayId];
            // @ts-ignore, this is a must, the prop doesn't exist on type anymore
            delete _pathwayState.pathwayId;
        });
    };
    update_105 = async (dbInstances) => {
        dbInstances.forEach(pathwayState => {
            const _pathwayState = pathwayState;
            // at first, add the label to be identical to the state to save time and error handling
            _pathwayState.label = pathwayState.name;
        });
    };
}
export const ModuleFE_Advisor_PathwayState = new ModuleFE_Advisor_PathwayState_Class();
export const dispatch_onPathwayTransitionChanged = new ThunderDispatcherV3('__onPathwayTransitionUpdated');
class ModuleFE_Advisor_PathwayTransition_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_PathwayTransition, dispatch_onPathwayTransitionChanged);
        this.registerVersionUpgradeProcessor('1.0.6', this.upgrade_1_0_6);
    }
    upgrade_1_0_6 = async (dbInstances) => {
        dbInstances.forEach(pathwayTransition => {
            const _pathwayTransition = pathwayTransition;
            _pathwayTransition.pathwayIds = [pathwayTransition.pathwayId];
            // @ts-ignore, this is a must, the prop doesn't exist on type anymore
            delete _pathwayTransition.pathwayId;
        });
    };
}
export const ModuleFE_Advisor_PathwayTransition = new ModuleFE_Advisor_PathwayTransition_Class();
export const ModulePack_Static_Pathway = [
    ModuleFE_Advisor_Action,
    ModuleFE_Advisor_OrderGroup,
    ModuleFE_Advisor_Pathway,
    ModuleFE_Advisor_PathwayState,
    ModuleFE_Advisor_PathwayTransition,
];
//# sourceMappingURL=pathway.js.map